(function() {
  'use strict';

  angular.module('eclipseApp.core').factory('brtSwitchCMS', [
    '$http',
    'uteEndpoint',
    '$q',
    '$rootScope',
    function($http, uteEndpoint, $q, $rootScope) {
      var service = {};
      service.brtSwitch = {};
      service.brtSwitch.fetchCMSComplete = false;
      service.brtSwitch.CheckUserApi = false; //add subsequent BRT flag in brtSwitch list
      service.brtSwitch.payNowEnhancementFlow = false;
      service.brtSwitch.callerIdFlow = false;
      service.brtSwitch.changePhoneNumberFlow = false;
      service.brtSwitch.showEmailNotification = false;
      service.brtSwitch.cancelledCTNForgotPassword = false;
      service.brtSwitch.isMigratedFlow = false;
      service.brtSwitch.fetchAddressBasedOffers = false;
      service.brtSwitch.showBillingMethod = false;
      service.brtSwitch.isHybridFlow = false; //  TODO fido-warroom: revert to false; rely on cms data
      service.brtSwitch.enableAALFlow = false;
      service.brtSwitch.enableAALTermFlow = false;

      var deferred = $q.defer();

      service.resetFlowDetails = function() {
        // this fn will be called during log-out to reset brtSwitch data
        service.brtSwitch.CheckUserApi = false;
        service.brtSwitch.payNowEnhancementFlow = false;
        service.brtSwitch.callerIdFlow = false;
        service.brtSwitch.changePhoneNumberFlow = false;
        service.brtSwitch.showEmailNotification = false;
        service.brtSwitch.cancelledCTNForgotPassword = false;
        service.brtSwitch.isMigratedFlow = false;
        service.brtSwitch.fetchAddressBasedOffers = false;
        service.brtSwitch.enableAALFlow = false;
        service.brtSwitch.enableAALTermFlow = false;
      };

      service.getBRTStatus = function() {
        $http({
          url: 'cms/ute/fido/resource/brtSwitchDetails.json',
          method: 'GET'
        })
          .success(function(data) {
            service.brtSwitch.fetchCMSComplete = true;
            if (_.isEmpty(data)) {
              deferred.reject(data);
              return deferred.promise;
            } else {
              var mapping = {};
              _.each(data, function(value) {
                if (value.CheckUserApi && value.CheckUserApi === true) {
                  service.brtSwitch.CheckUserApi = true;
                }
                if (value.payNowEnhancementFlow && value.payNowEnhancementFlow === true) {
                  service.brtSwitch.payNowEnhancementFlow = true;
                }
                if (value.callerIdFlow && value.callerIdFlow === true) {
                  service.brtSwitch.callerIdFlow = true;
                }
                if (value.changePhoneNumberFlow && value.changePhoneNumberFlow === true) {
                  service.brtSwitch.changePhoneNumberFlow = true;
                }
                if (value.showEmailNotification && value.showEmailNotification === true) {
                  service.brtSwitch.showEmailNotification = true;
                }
                if (value.cancelledCTNForgotPassword && value.cancelledCTNForgotPassword === true) {
                  service.brtSwitch.cancelledCTNForgotPassword = true;
                }
                if (value.isMigratedFlow && value.isMigratedFlow === true) {
                  service.brtSwitch.isMigratedFlow = true;
                }
                if (value.fetchAddressBasedOffers && value.fetchAddressBasedOffers === true) {
                  service.brtSwitch.fetchAddressBasedOffers = true;
                  mapping.fetchAddressBasedOffers = true;
                }
                if (value.showBillingMethod && value.showBillingMethod === true) {
                  service.brtSwitch.showBillingMethod = true;
                }
                if (value.isHybridFlow && value.isHybridFlow === true) {
                  service.brtSwitch.isHybridFlow = true;
                  mapping.isHybridFlow = true;
                }
                if (value.enableAALFlow && value.enableAALFlow === true) {
                  service.brtSwitch.enableAALFlow = true;
                }
                if (value.enableAALTermFlow && value.enableAALTermFlow === true) {
                  service.brtSwitch.enableAALTermFlow = true;
                }
              });
            }
            deferred.resolve(mapping);
          })
          .error(function(data) {
            deferred.reject(data);
          });
        return deferred.promise;
      };
      return service;
    }
  ]);
})();
